import React from 'react';

import { MobileFilterIcon } from '~/src/dash/components/icons/misc-icons';
import { MenuToggle } from '~/src/dash/components/toggles/MenuToggle';
import { Col, Cols, spacing, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { IActiveFilters } from '~/src/dash/views/dashboards/DashboardHome/common/common';

interface IProps {
  activeFilters: IActiveFilters;
  handleOnClick: () => void;
  isOpen: boolean;
}

export const DashboardFilterMenuToggle = ({ activeFilters, handleOnClick, isOpen }: IProps) => {
  const numActiveFilters = Object.values(activeFilters).filter((f) => !!f).length;
  return (
    <MenuToggle
      isActive={isOpen}
      onClick={handleOnClick}
      SvgIcon={MobileFilterIcon}
      iconStyle={{ height: '13px' }}
      style={{ height: '30px' }}
    >
      <Cols gap={spacing.small} style={{ alignItems: 'center' }}>
        <Col>
          <Text small bold color='inherit'>
            Filters
          </Text>
        </Col>
        {numActiveFilters > 0 && (
          <Col>
            <div
              style={{
                minWidth: '20px',
                borderRadius: '6px',
                backgroundColor: publicaColors.honeydew,
              }}
            >
              <Text extraSmall bold color='inherit'>
                {numActiveFilters}
              </Text>
            </div>
          </Col>
        )}
      </Cols>
    </MenuToggle>
  );
};
